import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { authRequest } from './api'

export default function AdminUsers() {
  const [users, setUsers] = useState([])

  useEffect(() => {
    async function fetchInfo() {
      return await authRequest('/admin/adminusers').then(setUsers)
    }

    fetchInfo()
  }, [])

  return (
    <div className="home-grid">
      <div className="home-users">
        <h1 className="home-title" style={{ marginBottom: '1.3em' }}>
          Admin Users
          <Link to={`/adminuser/new`} className="new-btn">
            New
          </Link>
        </h1>
        {users.length > 0 ? (
          <ul className="list">
            {users.map(({ name, _id, email }) => (
              <li key={_id} className="list-item item-flex">
                <Link to={`/adminuser/${_id}`}>{name}</Link>
              </li>
            ))}
          </ul>
        ) : (
          <div className="list">No Users yet</div>
        )}
      </div>
    </div>
  )
}
